module.exports = __webpack_public_path__ + "img/addNewBrand.bc857ef4.svg";